import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqData = [
  {
    id: "about-tap",
    section: "About TAP",
    questions: [
      {
        id: "what-is-tap",
        question: "What is TAP?",
        answer: "TAP (Talent Acquisition Platform) is a referral-powered hiring platform. Think of it as a side hustle where your network = opportunity. Refer talent to live vacancies and cash out rewards when they are successful."
      },
      {
        id: "who-can-use-tap",
        question: "Who can use TAP?",
        answer: "Anyone! You don't need to be a recruiter. If you know great people looking for new roles, or companies that are hiring, you can TAP in."
      },
      {
        id: "how-to-refer",
        question: "How do I refer someone?",
        answer: "Create an account, review the live vacancies and follow the easy steps to referring. There is also a referral fee for onboarding and referring clients."
      },
      {
        id: "refer-myself",
        question: "Can I refer myself for a role?",
        answer: "No, if you are looking for job please visit here and apply directly - (link to careers page)"
      },
      {
        id: "after-referral",
        question: "What happens after I make a referral?",
        answer: "We keep you updated in real time. You'll see when your referral applies, gets interviewed, and ultimately hired."
      },
      {
        id: "multiple-referrals",
        question: "What if multiple people refer the same candidate?",
        answer: "The reward goes to whoever referred first through TAP. Speed = key! Each candidate referred has a 6 month ownership period."
      }
    ]
  },
  {
    id: "rewards",
    section: "Rewards",
    questions: [
      {
        id: "how-get-rewarded",
        question: "How do I get rewarded for a referral?",
        answer: "If your referral gets hired, you get the reward listed for that role. It will be paid out into a mobile wallet for you to spend in our partnered stores in South Africa."
      },
      {
        id: "when-receive-reward",
        question: "When will I receive my reward?",
        answer: "As soon as the company confirms the hire and passes the probation period (don't worry, we'll keep you updated every step of the way)."
      },
      {
        id: "reward-if-not-hired",
        question: "Do I get rewarded even if my referral isn't hired?",
        answer: "Not yet, rewards are only paid out on successful hires. But every referral helps build your TAP credibility and increases your chances for future wins."
      },
      {
        id: "valid-referral",
        question: "Who qualifies as a valid referral?",
        answer: "Anyone who's a genuine fit for the role and not already in the company's hiring process."
      },
      {
        id: "refer-existing-employee",
        question: "Can I refer someone who already works at the company?",
        answer: "No. TAP is about helping companies find new talent."
      },
      {
        id: "referral-limits",
        question: "Are there limits on how many referrals I can make?",
        answer: "No limits. The more you refer, the more chances you have to earn rewards."
      },
      {
        id: "international-referrals",
        question: "Can people from outside my country make referrals?",
        answer: "Yes! As long as the job allows international candidates or remote work, anyone can TAP in."
      }
    ]
  },
  {
    id: "for-companies",
    section: "For Companies",
    questions: [
      {
        id: "why-use-tap",
        question: "Why should my company use TAP?",
        answer: "Because referrals are proven to deliver faster hires, better culture fits, and lower costs. With TAP, you instantly plug into a global network of referrers. The best people are referred by their peers."
      },
      {
        id: "what-roles",
        question: "What kind of roles can companies post?",
        answer: "From software engineers to designers to product managers, if you're hiring within tech & sales, TAP can help you fill it."
      },
      {
        id: "company-get-started",
        question: "How do we get started as a company?",
        answer: (
          <>
            Easy.{' '}
            <a 
              href="mailto:info@airtalent.co.za" 
              className="text-[#FF7A00] hover:underline"
            >
              Contact us
            </a>
            , share your job openings, and we'll set up your profile so referrals can start flowing in.
          </>
        )
      }
    ]
  },
  {
    id: "technical-support",
    section: "Technical & Support",
    questions: [
      {
        id: "is-free",
        question: "Is TAP free to join?",
        answer: "Yes, signing up is free. You only earn when a successful hire happens."
      },
      {
        id: "need-app",
        question: "Do I need to download an app?",
        answer: "No, TAP works right from your browser. Mobile and desktop friendly."
      },
      {
        id: "data-secure",
        question: "Is my data secure?",
        answer: "Absolutely. We take data privacy seriously and protect all your information with top-tier security standards."
      },
      {
        id: "technical-issues",
        question: "What if I have technical issues with the platform?",
        answer: (
          <>
            You can reach out to our support team directly at{' '}
            <a 
              href="mailto:info@airtalent.co.za" 
              className="text-[#FF7A00] hover:underline"
            >
              info@airtalent.co.za
            </a>
            . We'll get you sorted within 24 hours.
          </>
        )
      },
      {
        id: "contact-questions",
        question: "Who do I contact if I have questions or issues?",
        answer: (
          <>
            Our support team is always on hand. Just drop us a message at{' '}
            <a 
              href="mailto:info@airtalent.co.za" 
              className="text-[#FF7A00] hover:underline"
            >
              info@airtalent.co.za
            </a>
            .
          </>
        )
      },
      {
        id: "feedback-suggestions",
        question: "Where can I share feedback or suggestions for TAP?",
        answer: (
          <>
            We'd love that. Send your ideas to{' '}
            <a 
              href="mailto:info@airtalent.co.za" 
              className="text-[#FF7A00] hover:underline"
            >
              info@airtalent.co.za
            </a>
            , we're building TAP with you, for you.
          </>
        )
      }
    ]
  }
];

export default function FAQ() {
  return (
    <section className="bg-white relative pt-12 min-[375px]:pt-14 min-[425px]:pt-16 sm:pt-20 lg:pt-28 pb-12 min-[375px]:pb-14 min-[425px]:pb-16 sm:pb-20 lg:pb-24">
      <div className="flex flex-col w-full max-w-7xl mx-auto px-4 min-[375px]:px-6 min-[425px]:px-8 sm:px-6 lg:px-10">
        <div className="mb-8 min-[375px]:mb-10 min-[425px]:mb-12 lg:mb-20">
          <h2 className="text-2xl min-[375px]:text-3xl min-[425px]:text-4xl sm:text-4xl text-center lg:text-left md:text-5xl lg:text-[60px] font-bold text-[#2d2d2d] space-grotesk leading-[130%]">
            FAQs
          </h2>
        </div>

        <div className="w-full space-y-8 min-[375px]:space-y-10 min-[425px]:space-y-12">
          {faqData.map((section) => (
            <div key={section.id} className="w-full">
              <h3 className="text-lg min-[375px]:text-xl min-[425px]:text-2xl lg:text-2xl font-bold text-[#2D2D2D] font-space-grotesk leading-[130%] mb-4 min-[375px]:mb-6 uppercase">
                {section.section}
              </h3>
              <Accordion type="single" collapsible className="w-full space-y-3 min-[375px]:space-y-4">
                {section.questions.map((faq) => (
                  <AccordionItem 
                    key={faq.id} 
                    value={faq.id}
                    className="border-none"
                  >
                    <AccordionTrigger className="px-4 min-[375px]:px-6 py-3 min-[375px]:py-4 text-left hover:no-underline rounded-[10px] border border-[#EAEAEA] bg-white transition-colors duration-200 [&>svg]:text-[#FF7A00]">
                      <span className="text-sm min-[375px]:text-base min-[425px]:text-lg lg:text-lg font-semibold text-[#2D2D2D] font-space-grotesk leading-[130%] pr-3 min-[375px]:pr-4 [text-wrap:balance]">
                        {faq.question}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="px-4 min-[375px]:px-6 pb-4 min-[375px]:pb-6 pt-3 min-[375px]:pt-4">
                      <div className="text-sm min-[375px]:text-base lg:text-base font-medium text-[#241900] font-manrope leading-[140%] [text-wrap:pretty]">
                        {faq.answer}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
